










import Vue from "vue";
import { ActHistory } from '../models/ActHistory';
import { User } from '../models/User';

export default Vue.extend({
  name: 'ActHistoryCard',
  props: {
    actHistory: ActHistory
  },
  data() {
    return {
      user: null as User
    }
  },
  mounted() {
    this.actHistory.getUser()
      .then(u => this.user = u);
  }
});
